import enUS from "./lang/en-US.json";
import ploc from "./lang/qps-PLOC.json";
import frCA from "./lang/fr-CA.json";
import esMX from "./lang/es-MX.json";

export default {
  "en-us": {
    localeName: "English (United States)",
    localeData: enUS,
    shorthand: "English"
  },
  "fr-ca": {
    localeName: "Français",
    localeData: frCA,
    shorthand: "Français"
  },
  "qps-ploc": {
    localeName: "PseudoLoc",
    localeData: ploc,
    shorthand: "PseudoLoc"
  },
  "es-mx": {
    localeName: "Español (Mexico)",
    localeData: esMX,
    shorthand: "Español"
  }
};
